import React, {Component} from "react";
import './Payment.css'
import PaypalLogo from '../../../../../assets/img/pp-logo-200px.png';
import payment1 from '../../../../../assets/img/payment1.png';
import {FormattedMessage} from "react-intl";
import './Beginners.css';
import {PAGE_OPEN_TYPE} from "../../../../../configuration";
import cartImage from "../../../../../assets/img/cart-payment-1.png"
import placeOrderImage from "../../../../../assets/img/cart-payment-2.png"
import stirpePaymentImage from "../../../../../assets/img/cart-payment-3.png"
import visa_masterImage from "../../../../../assets/img/VisaAEMaster.png"
import MetaTags from "react-meta-tags";

class Payment extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }

    render() {
        return (
            <div className="static-pages">
                <MetaTags>
                    <title>支払いについて｜プリント基板のネット通販｜KITCUT PCB</title>
                    <meta property="title" content="支払いについて｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta name="title" content="支払いについて｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="background-div">

                    {/*<div>*/}
                    {/*<h3 className="payment-head">*/}
                    {/*<FormattedMessage id="app.payment.addprocedure"*/}
                    {/*defaultMessage="Add payment procedure on site after obtaining PayPal account"*/}
                    {/*description=""*/}
                    {/*/>*/}
                    {/*/!*PayPal アカウント取得後、サイトでの決済手順方法を追加*!/*/}
                    {/*</h3>*/}
                    {/*</div>*/}
                    <div className="row">
                        <div className="font-size-30 font-size-heading-mobile">
                            <p>
                                <FormattedMessage id="app.payment.aboutpayment"
                                                  defaultMessage="About payment"
                                                  description=""
                                />
                                {/*支払いについて*/}
                            </p>
                        </div>
                        {/*//////////////////////////////////////////////////////////////////////////////////////////*/}
                        <div className='all-content-font-size'>
                            <p>
                                ショッピングカートにて注文する基板を 選択しお支
                                払い手続きに進みます。
                                <br/>
                                注文確認画面にて お客様情報、お届け先住所に間違
                                いがないか ご確認のうえお支払いを選択してくださ
                                い。
                            </p>
                        </div>
                        <div className="resp-image">
                            <img src={cartImage} alt="Paypal" className="payment-img1 payment-image-mobile"/>
                        </div>
                        <div className="resp-image">
                            <img src={placeOrderImage} alt="Paypal" className="payment-img1 payment-image-mobile"/>
                        </div>
                        <div className="font-size-30 font-size-heading-mobile">
                            <p>
                                クレジットカード支払い
                            </p>
                        </div>
                        <div className='all-content-font-size'>
                            <p>
                                ご利用可能なクレジットカードは下記の３つです

                            </p>
                        </div>
                        <div className="resp-image">
                            <img src={visa_masterImage} alt="Paypal" className="payment-img1 payment-image-mobile-visa-master"/>
                        </div>
                        <div className="resp-image">
                            <img src={stirpePaymentImage} alt="Paypal" className="payment-img1 payment-image-mobile"/>
                        </div>
                        <div className='all-content-font-size'>
                            <p>
                                <div className="remove-padding-payment">「カード情報の入力」画面が表示されます。</div>
                                メールアドレス、カード番号、カード有効 期限セキュ
                                リティコード、所有者名を入力 し支払いボタンをク
                                リックてください。
                            </p>
                        </div>
                        <br/>
                        <div className='all-content-font-size'>
                            <p>
                                <div className="payment-color-link-responsive">【ご注意】クレジットカードを選択された場合</div>
                                お支払いは「一括払い」のみとなります。 分割払い
                                には対応しておりません。 クレジットカードのご利
                                用はご本人または 会社様名義のカードに限らせてい
                                ただきます
                            </p>
                        </div>
                        <br/>
                        <div className="font-size-30 font-size-heading-mobile">
                            <p>
                                ペイパルアカウントでの支払い
                            </p>
                        </div>

                        {/*//////////////////////////////////////////////////////////////////////////////////////////*/}

                        <div className="resp-image">
                            <img src={PaypalLogo} alt="Paypal" className="payment-img1"/>
                        </div>


                        <div className='all-content-font-size'>

                            <p>
                                {/*<FormattedMessage id="app.payment.paypal"*/}
                                {/*defaultMessage="What is PayPal (PayPal)? "*/}
                                {/*description=""*/}
                                {/*/>*/}
                                <b>PayPal(ペイパル)とは?</b>

                                <br/>
                                <FormattedMessage id="app.payment.transactions1"
                                                  defaultMessage="You can do transactions with just your ID and password by simply registering a credit or debit card or setting up a bank debit."
                                                  description=""
                                />

                                {/*クレジットカード、デビットカードを登録するか、銀行の口座振替設定を行うだけで、ID とパスワードのみでの取引が可能に。*/}
                                <br/>
                                <FormattedMessage id="app.payment.transactions2"
                                                  defaultMessage="You can use the payment information safely without telling the shop side. New registration is also free."
                                                  description=""
                                />

                                {/*お支払い情報をお店側に伝えることなく安全にご利用いただけます。新規登録も無料。*/}
                                <br/>
                                <FormattedMessage id="app.payment.transactions3"
                                                  defaultMessage="Credit and debit cards can be set from the purchase screen, and bank accounts can be set from PayPal's homepage."
                                                  description=""
                                />

                                {/*クレジットカード・デビットカードはご購入画面から、銀行口座はペイパルのホームページから設定できます。*/}
                            </p>
                        </div>

                        {/*<div className='all-content-font-size'>*/}
                        {/*<p>*/}
                        {/*<FormattedMessage id="app.payment.paypalpayment"*/}
                        {/*defaultMessage="PayPal (PayPal) payment [payment method] Credit card (VISA, MasterCard, JCB, American Express) Payment from the bank (Mizuho Bank, Sumitomo Mitsui Banking Corporation, Mitsubishi UFJ Bank, Japan Post Bank, Resona Bank, Resona Bank, Resona Bank To pay from a bank account with PayPal (PayPal), you need to make debit settings from within PayPal account. Please check the detailed steps below."*/}
                        {/*description=""*/}
                        {/*/>*/}

                        {/**/}
                        {/*<br/> 詳しいステップは下記よりご確認ください。*/}
                        {/*</p>*/}
                        {/*</div>*/}

                        <div className='all-content-font-size'>
                            <p>
                                「■PayPal(ペイパル)決済 【お支払い方法】 クレジットカード( VISA、MasterCard、JCB、アメリカン・エキスプレス ) 銀行からのお支払い(みずほ銀行、三井住友銀行、三菱 UFJ 銀行、ゆうちょ銀行、りそな銀行・埼玉りそな銀行) PayPal(ペイパル)で銀行口座から支払うには、ペイパルのアカウント内から口座振替設定が必要です。
                                詳しいステップは下記よりご確認ください。

                            </p>
                        </div>

                        <div className='all-content-font-size'>
                            {/* <p>
                            <a href="https://www.paypal.com/jp/webapps/mpp/paypal-stories/2018-09-13">
                                <FormattedMessage id="app.payment.viewsettings"
                                                  defaultMessage="View bank debit settings >>"
                                                  description=""
                                />

                                銀行の口座振替設定方法を見る>>
                            </a>
                        </p>*/}

                            <div className=" payment-img col-md-12 resp-image">
                                {/*<table border="0" cellPadding="10" cellSpacing="0" align="left">*/}
                                {/*<tr>*/}
                                {/*<td align="center">*/}

                                <div className="col-12">
                                    <a href="https://www.paypal.com/jp/webapps/mpp/merchant"
                                       onClick="javascript:window.open('https://www.paypal.com/jp/webapps/mpp/logo/about','olcwhatispaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=900, height=700');"
                                       target={PAGE_OPEN_TYPE}>
                                        <div className="resp-image">
                                            <img
                                                src="https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/jp/developer/319x110_b.png"
                                                border="0"
                                                alt="ペイパル｜カード情報も、口座番号も、ペイパルが守ります。｜VISA, Mastercard, JCB, American Express, Union Pay, 銀行"/>
                                        </div>
                                    </a>
                                </div>
                                {/*</td>*/}
                                {/*</tr>*/}
                                {/*</table>*/}
                            </div>
                            <br/>

                            <div>
                                <FormattedMessage id="app.payment.creditcardbankaccount"
                                                  defaultMessage="※ We can cope with settlement of credit card and bank account in business can."
                                                  description=""
                                />
                                {/*※ビジネスでクレジットカードや銀行口座の決済に対応 “できる”。*/}
                                <a href="https://www.paypal.com/jp/webapps/mpp/merchant/how-to-signup-business"
                                   target={PAGE_OPEN_TYPE}>
                                    <FormattedMessage id="app.payment.payment"
                                                      defaultMessage="Pay for payment (for business)"
                                                      description=""
                                    />

                                    {/*決済導入(ビジネス向け)へ*/}
                                </a><br/>
                                <FormattedMessage id="app.payment.caseoftroubles"
                                                  defaultMessage="※ With PayPal In the case of troubles such as item not delivered or others received, the purchase price is protected if the conditions are met."
                                                  description=""
                                />

                                {/*※PayPal なら「商品が届かない」「違うものが届いた」などのトラブル時、条件を満たせば購入金額を保護されます。*/}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <p className="static-pages-headings">
                            <FormattedMessage id="app.payment.registrationmethod"
                                              defaultMessage="PayPal registration method (account opening method)"
                                              description=""
                            />

                            {/*PayPal の登録方法 ( アカウント開設方法 )*/}
                        </p>

                        <p className="extra-margin-bottom all-content-font-size">
                            <a href="https://www.paypal.com/jp/webapps/mpp/personal/why-use-paypal"
                               target={PAGE_OPEN_TYPE}>
                                <FormattedMessage id="app.payment.personalaccount"
                                                  defaultMessage="Credit Card Payment-PayPal (PayPal) >> Open a free personal account >>"
                                                  description=""
                                />

                                {/*クレジットカード決済 -PayPal( ペイパル )>>無料個人向けアカウント開設>>*/}
                            </a><br/>

                            <a href="https://www.paypal.com/jp/webapps/mpp/merchant/how-to-signup-business"
                               target={PAGE_OPEN_TYPE}>
                                <FormattedMessage id="app.payment.businessaccount"
                                                  defaultMessage="Credit card payment-PayPal (PayPal) >> opening a free business account >> "
                                                  description=""
                                />

                                {/*クレジットカード決済 -PayPal( ペイパル )>>無料ビジネスアカウント開設>>*/}
                            </a><br/>

                        </p>

                        <h4>
                            さっそくPayPalをはじめよう
                        </h4>
                        <br/>
                        <div>

                        </div>
                        {/*/////////////////////////////////////////////////////////////////////////////////*/}
                        <div className="web-view-payment">
                            <div className="row resp-static-outer-padding">
                                <div className="col-md-3 text-center">
                                    <a href="https://www.paypal.com/jp/webapps/mpp/account-selection?locale.x=ja_JP"
                                       target="_blank">
                                        <img
                                            src="https://www.paypalobjects.com/digitalassets/c/APAC/04_paypal_apac_web_pagebuilder/jp/homepage/personal/how-to-signup-personal/step1-v2.png"
                                            alt=""/>

                                    </a>
                                </div>
                                <div className="col-md-9 font-size-14">
                                    <p><b>STEP１ 新規登録</b></p>
                                    <p>新規登録ボタンをクリックし、支払いに利用する場合は「パーソナルアカウント」を選択。</p>
                                </div>
                            </div>
                            <div className="row resp-static-outer-padding">
                                <div className="col-md-3 text-center">
                                    <a href="https://www.paypal.com/jp/webapps/mpp/support/add-card" target="_blank">
                                        <img
                                            src="https://www.paypalobjects.com/digitalassets/c/APAC/04_paypal_apac_web_pagebuilder/jp/homepage/personal/how-to-signup-personal/step2-v1.png"
                                            alt=""/>

                                    </a>
                                </div>
                                <div className="col-md-9 font-size-14">
                                    <p><b>STEP 2 住所と支払い情報を追加</b></p>
                                    <p>クレジットカード、デビットカードまたは銀行口座情報と個人情報を入力。支払い方法は複数登録が可能。</p>
                                    <p>アカウント登録後も編集できます。</p>
                                </div>
                            </div>
                            <div className="row resp-static-outer-padding">
                                <div className="col-md-3 text-center">
                                    <a href="https://www.paypal.com/jp/webapps/mpp/support/confirm-email"
                                       target="_blank">
                                        <img
                                            src="https://www.paypalobjects.com/digitalassets/c/APAC/04_paypal_apac_web_pagebuilder/jp/homepage/personal/how-to-signup-personal/step3-v4.png"
                                            alt=""/>

                                    </a>
                                </div>
                                <div className="col-md-9 font-size-14">
                                    <p><b>STEP３ メールアドレスを認証</b></p>
                                    <p>新規登録後、登録したメールアドレスに認証メールが届きます。
                                        メールアドレスの認証をして完了です。</p>
                                </div>
                            </div>
                        </div>



                        {/*/////////////////////////////////////////////////////////////////////////////////*/}
                        <div className="mobile-view-payment">
                            <div className="row resp-static-outer-padding">

                                <div className="col-md-9 font-size-14">
                                    <p><b>STEP１ 新規登録</b></p>
                                    <p>新規登録ボタンをクリックし、支払いに利用する場合は「パーソナルアカウント」を選択。</p>
                                </div>
                                <div className="col-md-3 text-center">
                                    <a href="https://www.paypal.com/jp/webapps/mpp/account-selection?locale.x=ja_JP"
                                       target="_blank">
                                        <img
                                            src="https://www.paypalobjects.com/digitalassets/c/APAC/04_paypal_apac_web_pagebuilder/jp/homepage/personal/how-to-signup-personal/step1-v2.png"
                                            alt=""/>

                                    </a>
                                </div>
                            </div>
                            <div className="row resp-static-outer-padding">

                                <div className="col-md-9 font-size-14">
                                    <p><b>STEP 2 住所と支払い情報を追加</b></p>
                                    <p>クレジットカード、デビットカードまたは銀行口座情報と個人情報を入力。支払い方法は複数登録が可能。</p>
                                    <p>アカウント登録後も編集できます。</p>
                                </div>
                                <div className="col-md-3 text-center">
                                    <a href="https://www.paypal.com/jp/webapps/mpp/support/add-card" target="_blank">
                                        <img
                                            src="https://www.paypalobjects.com/digitalassets/c/APAC/04_paypal_apac_web_pagebuilder/jp/homepage/personal/how-to-signup-personal/step2-v1.png"
                                            alt=""/>

                                    </a>
                                </div>
                            </div>
                            <div className="row resp-static-outer-padding">

                                <div className="col-md-9 font-size-14">
                                    <p><b>STEP３ メールアドレスを認証</b></p>
                                    <p>新規登録後、登録したメールアドレスに認証メールが届きます。
                                        メールアドレスの認証をして完了です。</p>
                                </div>
                                <div className="col-md-3 text-center">
                                    <a href="https://www.paypal.com/jp/webapps/mpp/support/confirm-email"
                                       target="_blank">
                                        <img
                                            src="https://www.paypalobjects.com/digitalassets/c/APAC/04_paypal_apac_web_pagebuilder/jp/homepage/personal/how-to-signup-personal/step3-v4.png"
                                            alt=""/>

                                    </a>
                                </div>
                            </div>
                        </div>

                        {/*/////////////////////////////////////////////////////////////////////////////////*/}

                    </div>

                    <div className="row">
                        <p className="static-pages-headings">
                            <FormattedMessage id="app.payment.otherpayment"
                                              defaultMessage="Other payment methods"
                                              description=""
                            />
                            {/*その他の支払い方法*/}
                        </p>

                        <p className='all-content-font-size'>


                            {/*現在は、PayPal を基本とさせていただいておりますが その他、支払い条件変更ご希望のお客様においては サポートより、ご連絡ください。*/}

                            現在は、クレジットカード支払い・PayPal 支払
                            いを基本とさせていただいておりますが、 その
                            他、お客様ご指定の商社を経由してのお支払いを
                            ご希望されるお客様においては <a onClick={()=>{document.getElementById("sub-title-span-resp").click()}}>お問い合わせ</a>よ
                            り、ご連絡ください。
                        </p>
                    </div>

                </div>
            </div>
        );
    }
}

export default Payment;



// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/Payment.js